import React from "react";

// The Table header component. In the Query Tool, this is used as the sticky header of the Table.
const TableHeader = ({ data_0 }) => {
  // Defines width for different colmns
  const getColumnWidth = (key) => {
    switch(key) {
      case 'Concept':
        return 'w-[10%]';
      case 'Keywords':
        return 'w-[20%]';
      case 'String':
        return 'w-4/12';
      default:
        return 'w-4/12';
    }
  };

  return (
    <thead
      style={{ position: "sticky", top: -1, height: "5vh", zIndex: 10 }}
      className="bg-slate-400 rounded-t-xl border-b border-neutral-200"
    >
      <tr>
        {data_0 &&
          Object.keys(data_0).map((key) => (
            <th key={key} className={`${getColumnWidth(key)} border border-gray-300 p-2 text-sm`}>{key}</th>
          ))} {/* Iterates through all the columns of the xlsx file and renders the columns*/}
        <th className="w-4/12 border border-gray-300 p-2 text-sm">System Generated String</th>  {/* System Generated columns that are not present in the xlsx, but shown in the table */}
        <th className="w-1/12 border border-gray-300 p-2 text-sm rounded-r-xl">Actions</th>
      </tr>
    </thead>
  );
};

export default TableHeader;